export default __webpack_public_path__ + "static/media/LLL Section 1 Preview.31c416e4.png";